/*!
 * IsEqual(a, b)
 *
 * Compares two expressions to determine if they are equal.
 * If the compared expressions are not of the same type,
 * AUTOMY attempts to convert them to the same type before the comparison.
 *
 * SAMPLES
 * IsEqual(1, True) -> True
 * IsEqual(0, False) -> True
 * IsEqual(Sum(3, 1), 4) -> True
 * IsEqual(1, True, 2) -> False
 *
 * INPUT
 * a, b, ...: The expressions to compare
 *
 * OUTPUT
 * Returns True if the compared expressions are equal, otherwise, False.
 */
function IsEqual(a, b) {
  return a == b;
}

/*!
 * IsNotEqual(a, b)
 *
 * SAMPLES
 * IsNotEqual(1, True) -> False
 * IsNotEqual(0, False) -> False
 * IsNotEqual(Sum(3, 1), 5) -> True
 *
 * Compares two expressions to determine if they are not equal.
 * If the compared expressions are not of the same type,
 * AUTOMY attempts to convert them to the same type before the comparison.
 *
 * INPUT
 * a, b: The expressions to compare.
 *
 * OUTPUT
 * Returns True if the compared expressions are not equal, otherwise, False.
 */
function IsNotEqual(a, b) {
  return a != b;
}

/*!
 * IsGreater(a, b)
 *
 * Compares two expressions to determine if the first is greater than the second one.
 * If the compared expressions are not of the same type,
 * AUTOMY attempts to convert them to the same type before the comparison.
 *
 * SAMPLES
 * IsGreater(5, 1) -> True
 * IsGreater(Sum(3, 1), 4) -> False
 * IsGreater("Zoo", "Park") -> True
 *
 * INPUT
 * a, b: The expressions to compare.
 *
 * OUTPUT
 * Returns True if a is greater than b, otherwise, False.
 */
function IsGreater(a, b) {
  return a > b;
}

/*!
 * IsGreaterOrEqual(a, b)
 *
 * Compares two expressions to determine if the first is greater or equal than the second one.
 * If the compared expressions are not of the same type,
 * AUTOMY attempts to convert them to the same type before the comparison.
 *
 * SAMPLES
 * IsGreaterOrEqual(5, 1) -> True
 * IsGreaterOrEqual(Sum(3, 1), 4) -> True
 * IsGreaterOrEqual(2, 5) -> False
 *
 * INPUT
 * a, b: The expressions to compare.
 *
 * OUTPUT
 * Returns True if a is greater or equal than b, otherwise, False.
 */
function IsGreaterOrEqual(a, b) {
  return a >= b;
}

/*!
 * IsLess(a, b)
 *
 * Compares two expressions to determine if the first is less than the second one.
 * If the compared expressions are not of the same type,
 * AUTOMY attempts to convert them to the same type before the comparison.
 *
 * SAMPLES
 * IsLess(1, 5) -> True
 * IsLess(Sum(3, 1), 4) -> False
 * IsLess("Art", "Zoo") -> True
 *
 * INPUT
 * a, b: The expressions to compare.
 *
 * OUTPUT
 * Returns True if a is less than b, otherwise, False.
 */
function IsLess(a, b) {
  return a < b;
}

/*!
 * IsLessOrEqual(a, b)
 *
 * Compares two expressions to determine if the first is less or equal than the second one.
 * If the compared expressions are not of the same type,
 * AUTOMY attempts to convert them to the same type before the comparison.
 *
 * SAMPLES
 * IsLessOrEqual(1, 5) -> True
 * IsLessOrEqual(Sum(3, 1), 4) -> True
 * IsLessOrEqual("Art", "Zoo") -> True
 *
 * INPUT
 * a, b: The expressions to compare.
 *
 * OUTPUT
 * Returns True if a is less or equal than b, otherwise, False.
 */
function IsLessOrEqual(a, b) {
  return a <= b;
}

/*!
 * IsNullOrEmpty(variable)
 *
 * Check if the field/variable has value or not.
 *
 * SAMPLES
 * IsNullOrEmpty("@existent_var") -> True
 * IsNullOrEmpty("@non_existent_var") -> False
 *
 * INPUT
 * variable: The field/variable to be checked.
 *
 * OUTPUT
 * Returns True if the field/variable has value and length > 0, otherwise, False.
 */
function IsNullOrEmpty(value) {
  return value == null || value.length === 0;
}

export default {
  IsEqual,
  IsNotEqual,
  IsGreater,
  IsGreaterOrEqual,
  IsLess,
  IsLessOrEqual,
  IsNullOrEmpty,
};
